import constant from "../../../_config/constant";

export const validatePhotos = (formData) => {
    const { photos, images } = formData

    let actualPhotos = photos ? photos : images

    const maxPhotos = constant.PROPERTY_IMAGES_COUNT
    const minPhotos = 1

    const errors = [];

    if (actualPhotos.length === 0) {
        errors.push({
            errorType: 'PHOTOS_REQUIRED',
            error: 'At least one photo must be added',
        });
    }

    if (actualPhotos.length < minPhotos) {
        errors.push({
            errorType: 'MIN_PHOTOS',
            error: `Minimum number of photos: ${minPhotos}`,
        });
    }

    if (actualPhotos.length > maxPhotos) {
        errors.push({
            errorType: 'MAX_PHOTOS',
            error: `Maximum number of photos: ${maxPhotos}. Now: ${actualPhotos.length}`,
        });
    }

    return {
        isValid: errors.length === 0,
        errors,
        summary: {
            totalPhotos: actualPhotos.length,
            maxAllowed: maxPhotos,
            hasErrors: errors.length > 0,
        }
    };
};